<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>

            <p>
                    短信签名建议为企业名称、已上线App、企业认证的公众号名称/小程序名称、已在工信部备案的网站名称等，若产品未上线建议先申请企业名称；严禁发送金融营销、赌博、诈骗、淫秽、色情、暴力等违规信息；
预计两小时完成审核，审核工作时间: 周一至周日9:00-23:00（法定节日顺延）
                </p>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol" style="max-width:700px;">
                
                <a-form-model-item ref="signname" label="签名名称" prop="signname">
                    <a-input v-if="is_vue_task" v-model="record.signname" placeholder="长度限2~12个字符, 建议为真实应用名/网站名/公司名" />
                    <span v-else>{{record.signname}}</span>
                    <div class="form_desc">
                     签名内容为短信发送方的已上线应用名称、已备案的网站名称、公司名称、商标名称等
                    • 若涉及到第三方权益必须获得第三方真实授权
                    • 不支持如“客户服务”、“友情提醒”等过于宽泛内容
                    • 不支持带有“测试”字样的签名，建议以实际已上线业务进行测试
                    • 若签名／模版内容侵犯到第三方权益必须获得第三方真实授权
                    • 无须添加【】、()、[]符号，签名发送会自带【】符号，避免重复
                    </div>
                <div class="form_desc">• 了解更多 <a :href="link1" target='_blank'>签名/模板申请规范</a></div>
                </a-form-model-item>

                <a-form-model-item ref="signorigin" label="签名来源" prop="signorigin">
                    <a-radio-group v-if="is_vue_task" name="" v-model="record.signorigin">
                      <a-radio v-for="item in signoriginNames" :value='item.value' :key="item.label" style="display:block;">{{item.label}}</a-radio>
                    </a-radio-group>
                    <span v-else>{{record.signoriginname}}</span>
                </a-form-model-item>

                <a-form-model-item ref="applytype" label="三证合一" prop="applytype">
                   <a-radio-group v-if="is_vue_task" name="" v-model="record.applytype">
                      <a-radio  style="display:block;" value="1">是</a-radio>
                      <a-radio  style="display:block;" value="0">否</a-radio>
                    </a-radio-group>
                    <span v-else>{{record.applytype}}</span>
                </a-form-model-item>

                <a-form-model-item ref="applypics" label="申请签名照片" prop="applypics">
                    <div class="applypics_box" v-show="record.applytype == '1'">
                        <uploader :btnName="'图片'" :maxFileCount="1" @handleFileChange="(filelist) => {handlePicChange(filelist,1)}" :picList="fileList_1"></uploader>
                        <p class="applypics_desc">三证合一</p>
                    </div>

                    <div class="applypics_box"  v-show="record.applytype == '1'">
                        <uploader :btnName="'图片'" :maxFileCount="1" @handleFileChange="(filelist) => {handlePicChange(filelist,2)}" :picList="fileList_2"></uploader>
                        <p class="applypics_desc">委托书</p>
                    </div>

                    <div class="applypics_box"  v-show="record.applytype == '0'">
                        <uploader :btnName="'图片'" :maxFileCount="1" @handleFileChange="(filelist) => {handlePicChange(filelist,3)}" :picList="fileList_3"></uploader>
                        <p class="applypics_desc">营业执照</p>
                    </div>

                    <div class="applypics_box"  v-show="record.applytype == '0'">
                        <uploader :btnName="'图片'" :maxFileCount="1" @handleFileChange="(filelist) => {handlePicChange(filelist,4)}" :picList="fileList_4"></uploader>
                        <p class="applypics_desc">组织机构代码证</p>
                    </div>

                    <div class="applypics_box"  v-show="record.applytype == '0'">
                        <uploader :btnName="'图片'" :maxFileCount="1" @handleFileChange="(filelist) => {handlePicChange(filelist,5)}" :picList="fileList_5"></uploader>
                        <p class="applypics_desc">税务登记证</p>
                    </div>

                    <div class="applypics_box"  v-show="record.applytype == '0'">
                        <uploader :btnName="'图片'" :maxFileCount="1" @handleFileChange="(filelist) => {handlePicChange(filelist,6)}" :picList="fileList_6"></uploader>
                        <p class="applypics_desc">委托书</p>
                    </div>
                    <div class="form_desc">
                        • 授权书请填写完成，签字并盖章
• 证照公章需为红色且清晰，请勿上传过期、自行涂改的文件
• 支持jpg、png、gif、jpeg格式的图片，每张图片不大于1.5MB
                    </div>
                    <div class="form_desc">• word模版下载：<a :href="link2">授权委托书</a></div>
                </a-form-model-item>

                <a-form-model-item ref="remark" label="申请说明" prop="remark">
                    <a-input type="textarea" v-if="is_vue_task" v-model="record.remark" />
                    <span v-else>{{record.remark}}</span>
                </a-form-model-item>

                <a-form-model-item ref="applyusercode" label="商户编码" prop="applyusercode">
                    <a-input v-if="is_vue_task" v-model="record.applyusercode" />
                    <span v-else>{{record.applyusercode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="applyusername" label="商户名称" prop="applyusername">
                    <a-input v-if="is_vue_task" v-model="record.applyusername" />
                    <span v-else>{{record.applyusername}}</span>
                </a-form-model-item>

                <a-form-model-item ref="plateorigin" label="签名申请平台" prop="plateorigin">
                    <a-input v-if="is_vue_task" v-model="record.plateorigin" />
                    <span v-else>{{record.plateorigin}}</span>
                </a-form-model-item>

                <a-form-model-item ref="signtype" label="签名作用域" prop="signtype">
                    <a-radio-group v-if="is_vue_task" name="" v-model="record.signtype">
                      <a-radio  style="display:block;" value="1">商户签名</a-radio>
                      <a-radio  style="display:block;" value="2">服务商签名</a-radio>
                    </a-radio-group>
                    <span v-else>{{record.signtype}}</span>
                </a-form-model-item>

                     <!-- :loading="confirmLoading" -->

                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import uploader from '../../../components/uploader'
const link1 = 'https://help.aliyun.com/document_detail/108077.htm?spm=a2c4g.11186623.2.6.37ac2edbg49CHU'
const link2 = 'https://041001.zhonglunnet.com/doc/%E6%8E%88%E6%9D%83%E4%B9%A6.doc'

const signoriginNames = [
    { label: '企事业单位的全称或简称', value: '0' },
    { label: '工信部备案网站的全称或简称', value: '1' },
    { label: '已上线APP应用的全称或简称', value: '2' },
    { label: '公众号或小程序的全称或简称', value: '3' },
    { label: '电商平台店铺名的全称或简称', value: '4' },
    { label: '商标名的全称或简称', value: '5' },
]
const m_title = {
    'addsignmanager':'新增签名',
    'detailsignmanager':'查看签名',
    'editsignmanager':'编辑签名',
};
export default {
    data() {
        return {
            link1,
            link2,
            signoriginNames,
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            rules: {
                signname: [
                    { required: true,pattern: /^(?!\s).{1,11}[^\s]$/, message: ' 长度限制为2~12个字符，数字、字母、字符、汉字均算作1个字符 ', trigger: 'blur' },
                ],
                signorigin:[
                    { required: true, message: '请选择签名来源', trigger: 'blur' },
                ],
                applytype:[
                    { required: true, message: '请选择', trigger: 'blur' },
                ],
                applypics:[
                    { required: true, message: '请选择', trigger: 'blur' },
                ],
                remark:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { min:2,max: 200, message: '请输入2 ~ 200个字符', trigger: 'blur' },

                ],
                applyusercode:[
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                applyusername:[
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                plateorigin:[
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                signtype:[
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                signname:'',
                signorigin:'',
                signoriginname:'',
                applytype:'0',
                applypics:'',
                remark:'',
                applyusercode:'',
                applyusername:'',
                plateorigin:'',
                signtype:'',

            },
            fileList_1: [],
            fileList_2: [],
            fileList_3: [],
            fileList_4: [],
            fileList_5: [],
            fileList_6: [],
            picResultList:['','','','','',''],
            picResultObj_1:{
                threelicenseonepic:'',
                mandatepic:'',
            },
            picResultObj_2:{
                businesslicense:'',
                organizationliceese:'',
                taxcertficate:'',
                mandatepic:'',
            },
            tempApplypics:{
                threelicenseonepic:'',
                mandatepic:'',
                businesslicense:'',
                organizationliceese:'',
                taxcertficate:'',
                
            }
        };
    },
    components:{
        uploader
    },
    methods: {
        handlePicResult(){
            //检查图片变化，组装图片
            let isPass = false;
            if(this.record.applytype == '1'){
                this.picResultObj_1.threelicenseonepic = this.picResultList[0] ? this.picResultList[0] : this.tempApplypics.threelicenseonepic;
                this.picResultObj_1.mandatepic = this.picResultList[1] ? this.picResultList[1] : this.tempApplypics.mandatepic;
                isPass = this.picResultObj_1.threelicenseonepic && this.picResultObj_1.mandatepic
            }
            else{
                this.picResultObj_2.businesslicense = this.picResultList[2] ? this.picResultList[2] : this.tempApplypics.businesslicense;
                this.picResultObj_2.organizationliceese = this.picResultList[3] ? this.picResultList[3] : this.tempApplypics.organizationliceese;
                this.picResultObj_2.taxcertficate = this.picResultList[4] ? this.picResultList[4] : this.tempApplypics.taxcertficate;
                this.picResultObj_2.mandatepic = this.picResultList[5] ? this.picResultList[5] : this.tempApplypics.mandatepic;
                isPass = this.picResultObj_2.businesslicense && this.picResultObj_2.organizationliceese && this.picResultObj_2.taxcertficate && this.picResultObj_2.mandatepic
            }
            if(isPass){
                this.record.applypics = this.record.applytype == '1' ? JSON.stringify(this.picResultObj_1) : JSON.stringify(this.picResultObj_2)
            }
            return isPass;
        },
        handlePicLoad(applypics){
            try {
                let pics = JSON.parse(applypics);
                this.tempApplypics = pics;
                if(this.record.applytype == 1){
                    this.fileList_1 = this.getDefaultPic(pics.threelicenseonepic);
                    this.fileList_2= this.getDefaultPic(pics.mandatepic);
                }
                else{
                    this.fileList_3 = this.getDefaultPic(pics.businesslicense);
                    this.fileList_4= this.getDefaultPic(pics.organizationliceese);
                    this.fileList_5 = this.getDefaultPic(pics.taxcertficate);
                    this.fileList_6= this.getDefaultPic(pics.mandatepic);
                }
            } catch (error) {
                this.tempApplypics = {}
                this.fileList_1 = [];
                this.fileList_2= [];
                this.fileList_3= [];
                this.fileList_4= [];
                this.fileList_5= [];
                this.fileList_6= [];
            }
        },
        getDefaultPic(filepath){
            let c_l = filepath.split('/').length;

            return [
                {
                    uid:this.G.generateUUID(),
                    name:filepath.split('/')[c_l - 1],
                    status: 'done',
                    url: this.C.OSS_LOCATION + filepath,
                }
            ]
        },
        handlePicChange(f_,i_){
            this.picResultList[i_-1] = f_[0];
        },
        handleOk() {
            let that = this;
            if(!this.handlePicResult()){
                this.message.error('请上传图片')
                return
            }
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    that.record.signoriginname = that.signoriginNames.find(i => i.value == that.record.signorigin).label;
                    if(params.action == 'editsignmanager'){
                        that.$store
                            .dispatch({
                                type: "wxtemplatemanager/editSmsSignApply",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addsignmanager'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "wxtemplatemanager/addSmsSignApply",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(id){
            this.$store.dispatch({
                type: "wxtemplatemanager/querySmsSignDetails",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    }
                    this.handlePicLoad(this.record.applypics)
                    console.log(this.record)
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "addsignmanager";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detailsignmanager'

    },

};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.form_desc{
white-space: pre-wrap;font-size:12px;line-height:1.5
}
.applypics_desc{
    text-align: center;
    font-size: 12px;
    line-height: 0;
}

.applypics_box{
    margin: 0 20px;
    width: 105px;
    display: inline-block;
}
</style>
